import * as Http from '../../api/Http.ts';
import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import * as AsyncRequest from '../../AsyncRequest.ts';
import * as AuthenticationState from '../state/AuthenticationState.ts';
import { AuthStatusType } from '../state/AuthenticationState.ts';
import { Response } from 'dg-web-shared/lib/HttpResponse.ts';
import * as LandingPageState from '../../landing-page/LandingPageState.ts';
import { WAS_IMPERSONATED } from '../../common/models/Authentication.ts';
import { removeQueryParam } from '../../utils/Utils.ts';
import { setAppToken } from '../components/Native.tsx';
import { NavigateFunction } from 'react-router-dom';
import { LocalStorageBase } from 'dg-web-shared/lib/LocalStorageBase.ts';

export const authTokenValidity = AsyncRequest.request(
    Http.OperatorAccount.Authentication.authTokenValidity,
    (store: Flux.Store, res: Response): string => {
        const authenticationState = new AuthenticationState.StateSlice(store);

        const adminName: string = res.body && res.body['adminName'];
        if (adminName) {
            try {
                LocalStorageBase.setStringItem(WAS_IMPERSONATED, adminName);
            } catch {
                // NOOP
            }
        }

        if (res.pending) {
            authenticationState.writeStatusPending(true);
        }
        if (res.statusCode.cls.success) {
            authenticationState.writeStatusPending(false);
            authenticationState.writeStatus(AuthStatusType.Authorized);
        }
        if (res.statusCode.cls.error) {
            authenticationState.writeStatusPending(false);
            authenticationState.writeStatus(AuthStatusType.Unauthorized);
        }
        return 'AuthenticationActions-authTokenValidity--log-ignore';
    },
);

export function login(navigate: NavigateFunction) {
    return AsyncRequest.request(
        Http.OperatorAccount.Authentication.getAuthToken,
        (store: Flux.Store, res: Response): string => {
            const authenticationState = new AuthenticationState.StateSlice(
                store,
            );
            if (res.statusCode.cls.success) {
                const otpStatus: LoginOtpStatus = res.body.otpStatus;
                switch (otpStatus) {
                    case LoginOtpStatus.DISABLED: {
                        setAppToken(res.body.appToken);
                        authenticationState.writeStatus(
                            AuthStatusType.Authorized,
                        );
                        LandingPageState.LoginState.reset(store);
                        break;
                    }
                    case LoginOtpStatus.ACTIVE: {
                        navigate('otp');
                        break;
                    }
                }
            }
            if (res.statusCode.cls.error) {
                LandingPageState.LoginState.stateWrite(store, {
                    showCredentialsError: res.statusCode.unauthorized,
                    showTurnstileError: res.statusCode.badRequest,
                });
            }
            return 'AuthenticationActions-login';
        },
    );
}

export enum LoginOtpStatus {
    DISABLED = 'DISABLED',
    ACTIVE = 'ACTIVE',
}

export const logout = AsyncRequest.request(
    Http.OperatorAccount.Authentication.deleteAuthToken,
    (_store: Flux.Store, res: Response): string => {
        if (res.statusCode.cls.success) {
            removeQueryParam('token');
            setAppToken(null);
            // on logout, reload url to reset all stores
            window.location.reload();
        }
        return 'AuthenticationActions-logout';
    },
);
